import z from "zod";

import { zSpecificationTyped } from "../specification/ZSpecification";
import { zAttrAccess } from "./ZAttrAccess";

export const zSpecAccess = zSpecificationTyped
  .pick({
    id: true,
    name: true,
    displayName: true,
    description: true,
    type: true,
  })
  .and(
    z.object({
      attributes: zAttrAccess.array(),
    }),
  );

export type ZSpecAccess = z.infer<typeof zSpecAccess>;
